export enum wordleTestId {
  alreadyUsedError = "word-already-used",
  closeButton = "word-close-button",
  distribution = "word-guess-distribution",
  explanation = "word-explanation",
  failPopup = "word-fail-popup",
  helpButton = "word-help-button",
  input = "word-text-input",
  instructions = "word-instructions-popup",
  noSuchWordError = "word-no-such-word",
  routineButton = "word-routine-button",
  shareButton = "word-share-button",
  successPopup = "word-success-popup",
  summaryDetails = "word-summary-details",
  summaryHeader = "word-summary-header",
  summarySubheader = "word-summary-subheader",
  moreGamesSection = "word-more-games",
}

export function wordleKeyboardTestId(key: string) {
  return `wordle-keyboard-${key}`;
}
